module.exports = __webpack_public_path__ + "img/icon_nav_exams.6a3eea1.svg";